/** Must match `release-name` in deploy workflows (`PostHog/upload-source-maps`). */
export const POSTHOG_RELEASE_NAME = "rivetai-product-app";

/** Commit SHA (or empty locally) — matches CI `release-version: ${{ github.sha }}`. */
export function readPosthogReleaseVersion(): string {
  return (process.env.REACT_APP_RELEASE_VERSION as string | undefined)?.trim() ?? "";
}
